var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 46.5",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0092 13.1607C26.2292 12.9833 26.5299 12.951 26.7851 13.0727C27.0388 13.1959 27.2001 13.4526 27.2001 13.7342V32.8011C27.2001 33.0827 27.0388 33.3393 26.7851 33.4611C26.6839 33.5095 26.5753 33.5344 26.4668 33.5344C26.304 33.5344 26.1412 33.4801 26.0077 33.3745L18.8753 27.6677H15.4667C14.6585 27.6677 14 27.0106 14 26.201V20.3343C14 19.5261 14.6585 18.8676 15.4667 18.8676H18.8753L26.0092 13.1607ZM32.7048 23.2333L29.3718 19.9C28.8761 19.4043 28.8761 18.6007 29.372 18.1049C29.8676 17.6096 30.6708 17.6096 31.1667 18.1049L34.5 21.4382L37.8336 18.1049C38.3294 17.6096 39.1325 17.6096 39.6282 18.1049C40.1239 18.6007 40.1239 19.4043 39.6282 19.9L36.2952 23.2333L39.628 26.5664C40.1238 27.0626 40.1238 27.866 39.628 28.3617C39.3801 28.6096 39.0555 28.7334 38.7307 28.7334C38.4059 28.7334 38.0811 28.6094 37.8334 28.3617L34.5 25.0282L31.1663 28.3617C30.9188 28.6096 30.594 28.7334 30.2689 28.7334C29.9443 28.7334 29.6195 28.6094 29.3718 28.3617C28.8761 27.8658 28.8761 27.0624 29.3718 26.5665L32.7048 23.2333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.996e73282887ca83a335aa346834b79b.svg";
export { ForwardRef as ReactComponent };